module.exports = __webpack_public_path__ + "media/images/themes/lemon_freshness/lemon_croped-18b821d93f306efd5444990956e8fe36.png";